import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export type MenuOption = "assessments" | "review" | "assign_reviewers" | "tasks_comparison";

export interface MenuState {
  selected: MenuOption | null;
  open: boolean;
}

const initialState: MenuState = {
  selected: null,
  open: false,
};

/* eslint no-param-reassign: 0 */
const filtersSlice = createSlice({
  name: "menu",
  initialState,
  reducers: {
    selectMenu(state, action: PayloadAction<MenuOption | null>) {
      state.selected = action.payload;
    },
    setOpen(state, action: PayloadAction<boolean | undefined>) {
      state.open = action.payload === undefined ? !state.open : action.payload;
    },
  },
});
/* eslint no-param-reassign: 1 */

export const { reducer } = filtersSlice;
export const { selectMenu, setOpen } = filtersSlice.actions;
